export default __webpack_public_path__ + "static/media/KFCbucket.82cffdd8.svg";